import StoreConfigOperations from "@/hooks/Gallery/gallery.gql"
import mergeOperations from "@/util/shallowMerge"
import {
  gql, useLazyQuery, useQuery 
} from "@apollo/client"
import {
  useEffect, useState 
} from "react"
import DEFAULT_OPERATIONS from "../Category/category.gql"


export const GET_CATEGORY = gql`
    query GetCategories(
        $id: String!
        $pageSize: Int!
        $currentPage: Int!
        $filters: ProductAttributeFilterInput!
        $sort: ProductAttributeSortInput
    ) {
        categories(filters: { category_uid: { in: [$id] } }) {
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            items {
                id
                uid
        url_key
        adv(currentPage: $currentPage) {
            id
            title
            img
            link
            page
            position
        }
            }
        }
        products(
            pageSize: $pageSize
            currentPage: $currentPage
            filter: $filters
            sort: $sort
        ) {
            items {
            id
            uid
            name
            # fabrics_mark
            stock_status
            version
            price_range {
                maximum_price {
                    final_price {
                        currency
                        value
                    }
                    regular_price {
                        currency
                        value
                    }
                    discount {
                        amount_off
                    }
                }
                minimum_price {
                    final_price {
                        currency
                        value
                    }
                    regular_price {
                        currency
                        value
                    }
                    discount {
                        amount_off
                    }
                }
            }
            sku
            image {
                url(type: "thumbnail", width: 320, height: 470)
            }
            hover_image(width: 320, height: 470)
            small_image {
                url(type: "thumbnail", width: 90, height: 132)
            }
            # TODO: 尺寸处理，列表色块
            # show_colors(
            #     width: 692
            #     height: 1016
            #     category_uid: $id #TODO: 筛选的颜色label
            #     filter_color: $filter_color
            # ) {
            #     items {
            #         label
            #         rgb
            #         image
            #         hover_image
            #         small_image
            #         small_hover_image
            #         is_selected
            #     }
            #     total
            # }
            # product_mark
            video_url
            stock_status
            # rating_summary
            # review_count
            __typename
            url_key
        }
        page_info {
            total_pages
        }

        total_count
        }
    }
`

export const useTryOnPage = (props) => {
  const operations = mergeOperations(
    DEFAULT_OPERATIONS,
    props.operations,
    StoreConfigOperations
  )

  const {
    getCategoryQuery 
  } = operations

  const [products, setProducts] = useState([])

  const {
    data: storeConfigData 
  } = useQuery(operations.getStoreConfigQuery, {
    fetchPolicy: "cache-and-network",
  })

  const storeConfig = storeConfigData ? storeConfigData.storeConfig : null

  const [
    runQuery,
    {
      called: categoryCalled, loading: categoryLoading, error, data 
    },
  ] = useLazyQuery(GET_CATEGORY, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-first",
  })

  useEffect(() => {
    runQuery({
      variables: {
        id: "MTAx",
        filters: {
          category_uid: {
            eq: "MTAx" 
          },
        },
        currentPage: 1,
        pageSize: 12,
      },
    })
  }, [runQuery])

  useEffect(() => {
    if (data && data.products) {
      setProducts(data.products.items)
    }
  }, [data])

  return {
    products, storeConfig 
  }
}
